import request from "@/utils/request.js";
import { APP_GEN_API } from "./config.js";
import _ from "lodash";

/**
 * 获取商店列表
 * - 默认日, keyword = "week" 就是周
 * @param {*} params
 */
export const getShopRank = (params) => {
  return request.get(APP_GEN_API.getShopRank, {params});
};